import React from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { useMemo } from "react";

export const AlwaysStripeProvider = ({
  children,
  stripeAccountId,
  amount,
  currency,
}: {
  children: React.ReactNode;
  stripeAccountId: string | undefined;
  amount: number;
  currency: "gbp" | "sgd";
}) => {
  const stripePromise = useMemo(() => {
    if (!stripeAccountId) return null;
    return loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY || "", {
      stripeAccount: stripeAccountId,
    });
  }, [stripeAccountId]);

  const stripeAmount = Math.round(amount);
  const canInitializePayment = Boolean(stripeAccountId) && stripeAmount > 0;

  return (
    <Elements
      stripe={canInitializePayment ? stripePromise : null}
      options={
        canInitializePayment
          ? {
              mode: "payment",
              amount: stripeAmount,
              currency,
              setup_future_usage: "on_session",
              allowedPaymentMethodTypes: ["card"],
            }
          : undefined
      }
    >
      {children}
    </Elements>
  );
};
